import { FC, ReactNode } from 'react'

type IProps = {
  children: ReactNode
}
const FormMain: FC<IProps> = ({ children }) => {
  return (
    <div className='relative bg-white p-6 pb-8 rounded-lg flex items-center shadow-sm'>
      {children}
    </div>
  )
}

export default FormMain
